import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-modal',
  imports: [NgClass],
  templateUrl: './modal.component.html',
  standalone: true,
})
export class ModalComponent {
  @Input() title: string = '';
  @Input() content: string = '';
  @Input() show: boolean = false;
  @Input() closeButtonLabel: string = 'Close';
  @Input() showCloseAction: boolean = true;
  @Input() confirm = true;
  @Input() confirmDisabled: boolean = false;
  @Input() confirmButtonLabel: string = 'Save Changes';
  @Input() confirmButtonStyle: 'primary' | 'secondary' | 'danger' | 'success' = 'primary';
  @Input() processing: boolean = false;
  @Input() showFooter: boolean = true;
  @Input() size: 'default' | 'wide' = 'default';
  @Input() compact: boolean = false;
  @Input() tall: boolean = false;
  @Input() allowOverflow: boolean = false;
  @Output() onClose = new EventEmitter<void>();
  @Output() onConfirm = new EventEmitter<void>();

  closeModal() {
    if (this.processing) return;
    this.onClose.emit();
  }

  confirmAction() {
    if (this.processing) return;
    this.onConfirm.emit();
  }
}
